export default "__VITE_ASSET__BcKcHPLe__"